export default __webpack_public_path__ + "static/media/1896.31b08fdb.png";